import { useEffect } from 'react';
import { useLocation, useNavigationType } from 'react-router-dom-v5-compat';
import { useDispatch } from 'react-redux';
import { locationChange } from 'stash/actions/router';

/**
 * Component that dispatches LOCATION_CHANGE actions when the route changes.
 * Allows middleware to listen for location changes and respond accordingly
 * (e.g., resetting session timeouts).
 */
export const LocationChangeDispatcher = () => {
	const location = useLocation();
	const navigationType = useNavigationType();
	const dispatch = useDispatch();

	useEffect(() => {
		dispatch(locationChange(location, navigationType));
	}, [location, navigationType, dispatch]);

	return null;
};
